<template>
    <div class="animated fadeIn">
        <DynamicCardList
                ref="dynamicCardList"
                caption="Mes commandes"
                :options="options"
                :searchFormStructure="dataSearchFormStructure"
                :columns="dataColumns"
                root="/order/list"
                :searchArgs="searchArgs">
        </DynamicCardList>
        <ModalInvoice ref="modalInvoice"></ModalInvoice>
    </div>
</template>

<script>
    import DynamicCardList from '../../components/DynamicCardList'
    import ModalTrash from '../../components/ModalTrash'
    import ModalInvoice from '../../components/ModalInvoice'
    export default {
        name: 'OrderList',
        components: {
            DynamicCardList,
            ModalTrash,
            ModalInvoice
        },
        props: {
            searchArgs: {
                type: Array,
                default: function () {
                    return []
                }
            },
            options: {
                type: Object,
                default: function () {
                    return {
                        pagination: true,
                        header: true,
                        responsive: false,
                        striped: true,
                        headerStyle: '1',
                        emptyText: 'Aucun résultat',
                        borderVariant: '',
                        noBody: false,
                        displayFilters: true
                    }
                }
            }
        },
        watch: {
        },
        mounted() {
            this.$refs.dynamicCardList.$refs.list.addAction('invoice', this.modelInvoiceOnClick, '', '<button class="btn btn-sm btn-light"><i class="fa fa-file-text"></i></button>', '', 'width:20px')
        },
        data: function () {
            return {
                Core: window.Core,
                dataSearchArgs: [],
                dataColumns: [
                    {
                        label: Core.Definition.getDefinition('ID'),
                        key: 'id',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('État'),
                        key: 'status',
                        type: 'select',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Date de création'),
                        key: 'creationDate',
                        type: 'date',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Produits'),
                        key: 'orderProductTitles',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Total'),
                        key: 'total',
                        sortable: true,
                        type: 'currency'
                    },
                    {
                        label: Core.Definition.getDefinition('Complété'),
                        key: 'totalCompleted',
                        sortable: true,
                        type: 'currency'
                    },
                    {
                        label: Core.Definition.getDefinition('Balance'),
                        key: 'totalBalance',
                        sortable: true,
                        type: 'currency'
                    }
                ],
                dataSearchFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'id'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'start'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'end'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'status'
                                        }
                                    ]
                                }
                            ]
                        },
                    ],
                    fields: [
                        {
                            id: 'id',
                            type: 'text',
                            label: Core.Definition.getDefinition('ID'),
                        },
                        {
                            id: 'status',
                            type: 'select',
                            label: Core.Definition.getDefinition('État'),
                            onSelect: function() {}
                        },
                        {
                            id: 'start',
                            type: 'date',
                            label: Core.Definition.getDefinition('Début'),
                        },
                        {
                            id: 'end',
                            type: 'date',
                            label: Core.Definition.getDefinition('Fin'),
                        }
                    ]
                },
                dataEdit: {
                    show: true,
                    text: '<button class="btn btn-sm btn-info"><i class="fa fa-edit"></i></button>',
                    onClick:  this.clickEdit
                }
            }
        },
        methods: {
            clickEdit(value, cell, row) {
                this.$router.push('/commerce/mes-commandes/' + row.id)
            },
            clickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            onTrashSuccess() {
                this.$refs.dynamicCardList.retrieve()
            },
            modelInvoiceOnClick(value, cell, row) {
                this.$refs.modalInvoice.instanceType = 'order'
                this.$refs.modalInvoice.instanceId = row.id
                this.$refs.modalInvoice.open = true
            }
        }
    }
</script>
